require([
    'jquery',
    'dayjs',
    'semantic',
    'semantic-calendar',
    'services',
    'ch_header',
    'ch_selectors',
    'ch_load_mask',
    'ch_form_validation',
], function ($, dayjs) {
    $(function () {
        $('[name=hub],[name=budget],[name=class_type]').dropdown();
        CH.semantic_form_validation = true;
        CH.validate('form_PrivateEvents', {submitHandler: false});

        $('.dates').calendar({
            type: 'date',
            minDate: dayjs().toDate(),
            formatter: {
                date: function (date, settings) {
                    return dayjs(date).format('MM/DD/YYYY');
                },
            },
        });
    });
});
